import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-400 to-orange-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">HV</span>
              </div>
              <div>
                <span className="text-xl font-bold text-white">Hi-Viz Pro Kenya Limited</span>
              </div>
            </div>
            <p className="text-sm mb-4 text-gray-400">
              Professional supplier of high-visibility safety wear and PPE, serving construction, 
              engineering, logistics, industrial, NGO, and institutional clients across Kenya.
            </p>
            <div className="flex space-x-4">
              <div className="flex items-center space-x-2 text-sm">
                <div className="w-6 h-6 bg-green-600 rounded flex items-center justify-center text-white font-bold text-xs">
                  ✓
                </div>
                <span>DOSHS Compliant</span>
              </div>
              <div className="flex items-center space-x-2 text-sm">
                <div className="w-6 h-6 bg-green-600 rounded flex items-center justify-center text-white font-bold text-xs">
                  ✓
                </div>
                <span>KEBS Certified</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-orange-500 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-orange-500 transition-colors text-sm">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-orange-500 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-orange-500 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm">+254 716 504 759</p>
                  <p className="text-xs text-gray-500">WhatsApp Available</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <a href="mailto:info@hivizprokenya.co.ke" className="text-sm hover:text-orange-500">
                  info@hivizprokenya.co.ke
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <p className="text-sm">Nairobi, Kenya</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Hi-Viz Pro Kenya Limited. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 mt-4 md:mt-0 justify-center">
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-orange-500" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-gray-500 hover:text-orange-500" data-testid="footer-terms-link">
              Terms & Conditions
            </Link>
            <Link to="/refund-policy" className="text-sm text-gray-500 hover:text-orange-500" data-testid="footer-refund-link">
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
